import { Component, Input, OnInit } from '@angular/core';
import { SkeletonBase, SkeletonSizeBase } from '../../../common';

@Component({
  selector: 'skc-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.less']
})
export class ChatComponent extends SkeletonSizeBase implements OnInit {
  @Input() conversations = 1;
  @Input('skc-show-avatar') showAvatar = true;

  constructor() {
    super();
  }

  ngOnInit() {}

  public get Conversations() {
    return new Array(this.conversations);
  }
}
